<template>
  <BreadCrumb PageTitle="Détails de l'abonnement" />
  <ViewAbonnement />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ViewAbonnement from "../../components/Abonnement/ViewAbonnement.vue";

  export default defineComponent({
    name: "ViewAbonnementPage",
    components: {
      BreadCrumb,
      ViewAbonnement,
    },
  });
</script>